import { LuTags } from "react-icons/lu";
import { Edition } from "./edition";
import { TableLayout } from "../../layouts/table";
import { CollectionSummary } from "../../../../components/collectionTools";
import { CategoryList } from "./categoryList";
import { getCategoryList } from "./categoryListModel";
import "./style.css";
export const Categories = () => (
  <section className="catalogsReference categoriesReference">
    <TableLayout
      title="Categorías"
      addText="Nueva categoría"
      edition={<Edition />}
      get={getCategoryList}
      idKey="categoryId"
      identificator="categories"
      renderSummary={(rows) => (
        <CollectionSummary
          items={[
            { label: "Categorías", icon: <LuTags />, value: rows.length },
          ]}
        />
      )}
      renderContent={(rows, onEdit) => (
        <CategoryList rows={rows} onEdit={onEdit} />
      )}
    />
  </section>
);
